export default __webpack_public_path__ + "static/media/wc.d8771573.jpg";